import React, {useState} from "react";
import { ModalComponent } from "../../../../components/Modal.components";
import { Boxed } from "../../../../components/Boxed.components";
import { Button } from "../../../../components/Button.components";
import { PageTitle } from "../../../../components/style";
import { components } from "react-select";
import { Avatar } from "../../../../components/Avatar.components";
import {
  AsyncSelect,
  RadioButton,
  RadioWrapper,
} from "../../../../components/Input.components";

export const ExportReport = (props) => {
  //State props

  const { exportReportModal, usersList } = props;

  //Dispatch props
  const {
    closeModal,
    exportReportsCsv,
    exportReportsPdf,
    form: { getFieldProps, resetFields },
  } = props;

  const [fileType, setFileType] = useState("csv")
  const [emails,setEmails] = useState([])

  const onOptionChange = e => {
    setFileType(e.target.value)
  }
  const CustomUserOption = (props) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <Avatar
          size={"24px"}
          src={data?.extra?.profilePictureUrl ?? ""}
          name={data?.label}
        />
      </components.Option>
    );
  };

  const addEmail = (val) => {
    const allEmails = val.map(v => v.value)
    setEmails(allEmails)
  }
  const CustomMultiValueLabel = (props) => {
    const { data } = props;
    return (
      <components.MultiValueLabel {...props}>
        <Avatar
          size={"24px"}
          src={data?.extra?.profilePictureUrl ?? ""}
          name={data?.label}
        />
      </components.MultiValueLabel>
    );
  };

  const exportReport = () => {
    if(fileType === "csv"){
      exportReportsCsv(emails)
      return
    }
    if(fileType === "pdf"){
      exportReportsPdf(emails)
      return
    }

  }
  return (
    <ModalComponent
      show={exportReportModal}
      onHide={closeModal}
      title={<PageTitle margin="5px 0">Export Report</PageTitle>}
      footer={
        <Boxed display="flex" width="100%">
          <Button clear onClick={closeModal}>
            Cancel
          </Button>
          <Button
            margin="0 0 0 auto"
            onClick={exportReport}
          >
            Send Report
          </Button>
        </Boxed>
      }
    >
      <Boxed>
        <AsyncSelect
          label="Select Viewers"
          isMulti
          placeholder="Select Viewers"
          options={usersList?.map((item) => ({
            label: `${item?.lastName} ${item?.firstName}`,
            value: item.email,
            extra: item,
          }))}
          components={{
            Option: CustomUserOption,
            MultiValueLabel: CustomMultiValueLabel,
          }}
          {...getFieldProps("sendTo", {
            initialValue: '',
            rules: [{ required: true }],
            onChange: (val) => addEmail(val)
          })}
          height="auto"
        />
        <Boxed margin="20px auto">
          <RadioWrapper>
            <input type='radio' name="export" value="csv" checked={fileType === "csv"} onChange={onOptionChange}/>
            CSV
            <span className="checkmark"></span>
          </RadioWrapper>
          <RadioWrapper>
            <input type='radio' name="export" value="pdf" checked={fileType === "pdf"} onChange={onOptionChange}/>
            PDF
            <span className="checkmark"></span>
          </RadioWrapper>
        </Boxed>
      </Boxed>
    </ModalComponent>
  );
};

